import { FC } from "react";
import { MainContentWrapper } from "../../layouts/base/MainContentWrapper";
import { MainContentHeader } from "../../layouts/base/MainContentHeader";
import { useTitlePage } from "../../hooks/use-title-page";
import { Stack, Typography } from "@mui/material";
import { ParagraphSection } from "../../components/common/ParagraphSection";

const title = "תקנון ותנאי שימוש";
const TermsPage: FC = () => {
  useTitlePage(title);
  return (
    <MainContentWrapper>
      <MainContentHeader title={title} />
      <Stack gap={2}>
        <Typography fontWeight={700} variant="h5" gutterBottom>
          תקנון ותנאי שימוש לאפליקציית "אחד"
        </Typography>

        <ParagraphSection
          title="1. מטרת האפליקציה"
          paragraphs={[
            `האפליקציה "אחד" (להלן: "האפליקציה") היא פלטפורמת תוכן בנושא יהדות ורוחניות.`,
            `בעל האפליקציה רשאי להוסיף שירותים ו/או מוצרים בגישה חופשית או בתשלום לפי שיקול דעתו.`,
          ]}
        />

        <ParagraphSection
          title="2. הגדרות"
          paragraphs={[
            `המשתמש/ת ו/או הגולש/ת– כל אדם, או ישות משפטית אשר גולשים/מבקרים באפליקציה.`,
            `הבעלים – נוריאל אהרן ודב בער דצינגר שכתובת הדואר האלקטרוני שלהם היא: Support@echadapp.com`,
            `שם האפליקציה – "אחד".`,
            `התקנון – מסמך זה על כל הוראותיו וסעיפיו.`,
          ]}
        />

        <ParagraphSection
          title="3. כללי"
          paragraphs={[
            `תקנון זה, כולל בין היתר תנאי שימוש, הוראות בדבר שמירה על פרטיות, הוראות בנושא שמירה על קניין רוחני. אנא קרא/י בעיון את כל תנאי השימוש. אם אינך מסכים לאחת ו/או יותר מהוראות התקנון, עליך להימנע מכל שימוש באפליקציה.`,
            `המשתמש/ת מסכים, בעצם פעולת הכניסה והגלישה באפליקציה, לכל הוראות התקנון.`,
            `המשתמש/ת מצהיר כי הוא מעל גיל 18, ואם הוא מתחת לגיל 18 אזי מצהיר כי הגלישה באפליקציה נעשית בהסכמת האחראי עליו כנדרש בדין.`,
            `התקנון מנוסח בלשון זכר, אולם מכוון לשני המינים.`,
            `מובהר ומודגש כי תקנון זה על מלוא הוראותיו, יחייב כל אדם אשר משתמש באפליקציה, ו/או רוכש דרכו שירותים או מוצרים ו/או משתמש אשר רכש מוצר ו/או שירות עבור צד ג'.`,
            `תנאי התקנון חלים ומחייבים על אדם אשר עושה שימוש באפליקציה, צופה בה, ו/או מבצע בה כל פעולה אחרת, בכל מכשיר ובכל מדיה שהיא, וללא הגבלת מקום גיאוגרפי.`,
            `במקרה של סתירה בין הוראות התקנון לבין הוראות הסכמים אחרים ו/או הוראות פרסומים אחרים המתייחסות לאפליקציה, יגברו תנאי התקנון.`,
          ]}
        />

        <ParagraphSection
          title="4. פרטיות"
          paragraphs={[
            `בעל האפליקציה מכבד את פרטיות הגולשים ופועל לפי כל דין. לקריאת מדיניות הפרטיות המלאה יש להיכנס לקישור "מדינות פרטיות" בעמוד הבית של האפליקציה. (מדיניות פרטיות במסמך נפרד)`,
            `מבלי לגרוע מהאמור במדיניות הפרטיות, בעל האפליקציה מקבל בהסכמת הגולשים פרטי יצירת קשר – שם ו/או כתובת דואר אלקטרוני ו/או מספר טלפון - ממשתמשים אשר מסרו בהסכמה את פרטיהם, וזאת על מנת לצרפם לרשימת תפוצה, ליצור איתם קשר טלפוני, לשלוח סקירות ומידע, או לשלוח מידע שיווקי או פרסומי אשר עשוי לעניין את משתמשים אלו. אם אינכם מעוניינים להיכלל ברשימה, או אם פרטי הקשר שלכם נכנסו בשוגג לרשימת התפוצה יש לשלוח הודעת הסרה (הודעת סירוב) לכתובת דוא"ל Support@echadapp.com או ללחוץ על הקישור הייעודי המצורף עבור הסרה במייל/ניוזלטר שישלח אליך.`,
            `לצורך רישום לאפליקציה והשלמת רכישה, בעל האפליקציה רשאי לבקש מהמשתמשים למסור פרטים אישיים כגון שם, טלפון, כתובת דוא"ל וכיוצא בזה.`,
            `מובהר בזאת כי על המשתמש לא חלה חובה שבדין למסור את המידע, והמסירה נעשית בהסכמתו ומרצונו החופשי.`,
          ]}
        />

        <ParagraphSection
          title="5. קניין רוחני"
          paragraphs={[
            `5.1 בעל האפליקציה מתייחס בחומרה ובכובד ראש להפרת זכויות יוצרים. בעל האפליקציה אוכף בקפידה את זכויותיו בכל האמצעים החוקיים אשר עומדים לרשותם.`,
            `5.2 הקניין הרוחני באפליקציה – לרבות אך לא רק - סימני מסחר, זכויות יוצרים, עיצובים, לוגואים, מאגרי מידע, שם הדומיין, טקסטים, תמונות, דימויים, סודות מסחריים, מידע עסקי ו/או כל נכס/קניין רוחני אחר, שייכים לבעל האפליקציה, או לצד ג' אשר הרשה את שימושם או הצגתם באפליקציה וזאת אלא אם צוין אחרת. אם הנך מזהה הפרה, אנא פנה אל בעלי האפליקציה בכתובת דוא"ל Support@echadapp.com ובעל האפליקציה יברר ויסדיר את העניין תוך זמן סביר מקבלת הפניה.`,
            `5.3 אין למשתמש באפליקציה אישור או רשות לעשות שימוש מסחרי בקניין הרוחני באפליקציה, ו/או כל שימוש שעומד בניגוד להוראות התקנון, אלא אם כן קיבל לכך אישור בכתב מבעל האפליקציה.`,
            `5.4 אין לעשות שימוש בשם האפליקציה ו/או בשם הדומיין, או בתוכנם בכל דרך אשר יכולה להטעות, לפגוע במוניטין, ליצור גניבת עין ו/או הטעיה, או בכל דרך אחרת אשר יכולה לגרום לנזק ממוני או אחר לבעל האפליקציה ו/או לצד ג'.`,
            `5.5 ייתכן ובאפליקציה יהיו קישורים (hyperlinks) אשר מפנים לאתרים חיצוניים (להלן 'אתרים חיצוניים') שאינם בבעלות בעל האפליקציה ואינם בשליטתו. הקניין הרוחני באתרים חיצוניים הינו בבעלות צד ג' ואין לבעל האפליקציה כל זכות בהם. אין בעצם הטמעת הקישורים באפליקציה כדי להרשות, או לאשר כל פעולה שהיא ביחס לנכסי קניין רוחני באתרים החיצוניים. אם מצאת את האתרים אליהם מפנים הקישורים כפוגעניים או ככאלה אשר מפרים את הדין אנא ידע את בעל האפליקציה בהקדם בכתובת Support@echadapp.com והוא יפעל לבירור התלונה וטיפול בה.`,
            `5.6 בנוסף, באפליקציה עשויות להופיע פרסומות שמקורן בחברות ו/או עסקים ו/או צדדי ג' אחרים שאינם בבעלות ו/או באחריות בעל האפליקציה. אין לבעל האפליקציה כל אחריות בנוגע לתוכן פרסומות אלו. אם נתקלתם בפרסומת פוגענית ו/או פרסומת אשר מפרה את החוק אנא פנו אל בעלי האפליקציה בכתובת Support@echadapp.com בבקשה להסרת הפרסומת.`,
          ]}
        />

        <ParagraphSection
          title="6. זמינות האפליקציה"
          paragraphs={[
            `6.1 בעל האפליקציה עושה כמיטב יכולתו כדי שהאפליקציה תפעל באופן תקין ותהיה זמין לגלישה רציפה. יחד עם זאת, אין התחייבות מצד בעל האפליקציה כי האפליקציה תפעל בכל עת. יתכנו שיבושים בזמינות / צפייה / גלישה באפליקציה אשר עשויים לנבוע מעדכונים ו/או עבודות תשתית, ו/או תקלות במחשב האישי של המשתמש, ספק האינטרנט שלו, שרת חיצוני, או בתשתית הגלישה שלו. כמו כן יתכנו תקלות הנובעות משירות האחסון של האפליקציה, פריצה או גורמים אחרים. בעל האפליקציה ישתדל להודיע מראש על הפרעות מתוכננות בגלישה אולם אינו מחויב לכך.`,
            `6.2 בעל האפליקציה שומר את הזכות להפסיק או לשנות את פעילות האפליקציה וזאת ללא הודעה מוקדמת.`,
          ]}
        />

        <ParagraphSection
          title="7. הוראות שחרור מאחריות"
          paragraphs={[
            `7.1 האפליקציה מאוחסנת בשרת אשר מאובטח על ידי חברה חיצונית. בעל האפליקציה אינו אחראי לנזק אשר יגרם כתוצאה מפריצה חיצונית לאפליקציה – בין היתר – הפצת/מכירת מידע כתוצאה מפריצה לאפליקציה, שיבוש במידע, פגיעה בזכויות יוצרים או קניין רוחני אחר, או כל נזק אחר שיגרם כתוצאה מחבלה באפליקציה ובתכניו.`,
            `7.2 בעל האפליקציה אינו אחראי לתוכן מודעות חיצוניות (תמונות/קישורים) אשר עשויות להופיע /להיטמע באפליקציה או לתוכן/מידע אשר מופיע באתרים אליהם הקישורים מובילים. בעל האפליקציה ו/או מי מטעמו אינו מפקח או בודק את כל התוכן האתרים אליהם מפנים הקישורים.`,
            `7.3 אם נתקלת במודעה/קישור פוגעני ו/או תמונה פוגענית ו/או כזה אשר מפנה לאפליקציה בעל תוכן פוגעני אנא הודע/י לבעל האפליקציה בכתובת דואר אלקטרוני Support@echadapp.com והוא יפעל להסדיר את העניין בהקדם האפשרי.`,
            `7.4 בעל האפליקציה מפרסם באפליקציה מעת לעת פרסומים, תכנים ומשתף ידע מקצועי וכיוצא בזה (להלן "פרסומים"). האמור בפרסומים הינו על דעת בעל האפליקציה בלבד ולמטרות סקירה, העשרה ושיווק בלבד. אין לראות באמור בפרסומים יעוץ מקצועי, ו/או המלצה, ו/או הנחיה והם אינם מהווים תחליף לאלו ואין להסתמך עליהם ככאלו. בנוסף, ייתכן ויהיו באפליקציה שגיאות ו/או אי-דיוקים כתוצאה מתום לב, ו/או מצב שבו תוכן בפרסום לא יהיה עדכני. בעל האפליקציה לא ישא באחריות בגין כל נזק שנגרם למשתמש בשל הסתמכות על האמור בפרסום ולא יחוב כלפי המשתמש בגין הסתמכות כזו.`,
            `7.5 האפליקציה מציעה הדרכות ו/או תרגילי מדיטציה. המשתמש בשירותי האפליקציה מצהיר בזאת כי למיטב ידיעתו והבנתו אין לו כל מניעה ו/או הגבלה בריאותית ו/או נפשית לעשות שימוש בשירותי האפליקציה. ככל ויש למשתמש מניעה ו/או הגבלה כזו, ו/או ככל שהמשתמש חווה קשיים או בעיות רפואיים ו/או נפשיים, הרי שעליו להתיעץ עם גורם מקצועי מוסמך לפני השימוש באפליקציה.`,
            `7.6 האפליקציה ושירותיה אינם מציעים ומספקים ייעוץ ו/או טיפול מקצועי מוסמך, ואינם באים במקום ייעוץ רפואי ו/או נפשי ו/או כל ייעוץ מקצועי אחר. ככל שמשתמש באפליקציה מסתמך על האמור בה, הוא עושה זאת מבחירתו ועל אחריותו הבלעדית ולאחר שהובהר לו כי עליו להתייעץ עם אנשי מקצוע ויועצים רלוונטיים לתחום. משתמש אשר הסתמך על תכני האפליקציה, מוותר בזאת על כל טענה ו/או דרישה ו/או תביעה כלפי בעל האפליקציה. בעל האפליקציה יהיה פטור מכל פיצוי ו/או חיוב ו/או שיפוי ביחס לנזקים שנגרמו למשתמש.`,
            `7.7 היה וסמכויות שיפוט כלשהן אינן מאפשרות החרגות או הגבלות כאמור לעיל, ההחרגות וההגבלות הנזכרות לעיל לא תחולנה במלואן, אלא רק במידה המקסימאלית המותרת על פי הדין החל.`,
          ]}
        />

        <ParagraphSection
          title="8. איסור פגיעה באפליקציה ושימושים אסורים"
          paragraphs={[
            `8.1 אין לבצע כל פעולה באופן ישיר או על ידי צד ג', אשר עשויה לפגוע באפליקציה, בזמינות הגלישה שבה, או בתוכן המוצג בה, או לשבש את פעולתה. אין לעשות שימוש בקוד תוכנה או כל פעולה אלקטרונית/דיגיטלית ו/או אוטומטית אחרת לרבות – וירוס ו/או 'תולעת' ו/או 'בוט' למטרת פגיעה כאמור באפליקציה.`,
            `8.2 אין לבצע כל פעולה אשר עשויה לשבש ו/או להכביד את פעולתם התקינה של מחשבי ושרתי בעל האפליקציה.`,
            `8.3 אין לבצע כל פעולה אשר עשויה למחוק ו/או לשבש ו/או לגרום לשינוי במידע של בעל האפליקציה.`,
            `8.4 אין לחדור לחומרי מחשב ו/או מידע אשר שייכים לבעל האפליקציה.`,
            `8.5 אין לעשות שימוש מטריד ו/או פוגעני בשירותי האפליקציה.`,
            `8.6 למשתמש ו/או לצד ג' אסור לבצע כל פעולה אשר נועדה לעשות שימוש באפליקציה ו/או בתכניו למטרה מסחרית ו/או למטרת לימוד מכונה ו/או לכל מטרה אחרת, מבלי שקיבל לכך אישור מבעל האפליקציה. בסעיף זה 'תכני האפליקציה' – תכני טקסט, תמונות, עיצובים, גרפיקות, קטעי וידאו ו/או סאונד ו/או פרטים אישיים של המשתמשים, מידע סטטיסטי על אודות פעילות המשתמשים, קוד תוכנה.`,
            `8.7 בעל האפליקציה רשאי על פי שיקול דעתו, לחסום ו/או להגביל גישה, כל משתמש באפליקציה אשר הפר אחת, או יותר, מהוראות תקנון זה. כן הוא רשאי להסיר מרשימת התפוצה משתמש שהפר אחת ו/או יותר מהוראות התקנון. למשתמש שנחסם ו/או שגישתו הוגבלה לא תהיה כל זכות לפיצוי ו/או שיפוי מצד בעל האפליקציה.`,
          ]}
        />

        <ParagraphSection
          title="9. אחריות המשתמש"
          paragraphs={[
            `9.1 המשתמש/ת והוא בלבד אחראי לכל נזק שיגרם כתוצאה מהפרת הוראות התקנון.`,
            `9.2 המשתמש ישפה את בעל האפליקציה בגין כל נזק, כלכלי או אחר, ו/או תביעה או דרישה של צד ג' כלשהו שיגרמו כתוצאה מכל אחד מאלה: (1) הפרה של אחת או יותר מהוראות התקנון; (2) שימוש באפליקציה ו/או בתכנים שלא בהתאם לתקנון זה; (3) הפרה מצד המשתמש של כל זכות של צד שלישי, לרבות (אך לא רק), זכויות קניין רוחני או הזכות לפרטיות; (4) כל נזק מכל סוג שהוא, בין אם נזק ישיר, עקיף, מיוחד או תוצאתי, שגרם לצד שלישי אשר קשור לשימושו באפליקציה או בתכנים. מבלי לגרוע מהאמור, המשתמש ישא גם בהוצאות משפטיות, עלויות שכר טרחת עו"ד, ו/או בעלי מקצוע אחרים, ו/או הוצאות אחרות שיהיו בזיקה לנזק שנגרם, כתוצאה מכל הסיבות שנמנו לעיל.`,
            `9.3 המשתמש ישפה את בעל האפליקציה בתוך 14 ימים מקבלת הודעה בדבר נזק שנגרם.`,
          ]}
        />

        <ParagraphSection
          title="10. עדכונים ושינויים"
          paragraphs={[
            `10.1 בעל האפליקציה שומר את הזכות לעדכן מעת לעת ולפי הצורך את תקנון האפליקציה.`,
            `10.2 על בעל האפליקציה לא תחול החובה לעדכן את המשתמשים בשינויים בתקנון ובתנאי השימוש; יחד עם זאת, לפני שינויים מהותיים, בעל האפליקציה יודיע על כך למשתמש.`,
            `10.3 תוקפם של השינויים יחול מרגע שינויים/עדכונם, והנוסח החדש יהיה זה אשר מחייב את המשתמשים.`,
          ]}
        />

        <ParagraphSection
          title="11. השימוש באפליקציה - כללי"
          paragraphs={[
            `11.1 ניתן להשתמש באפליקציה, וזאת בחינם וללא עלות. על מנת להתחבר ולהשתמש באפליקציה יש לעשות חיבור (login) באמצעות חשבון google או Apple.`,
            `11.2 בעל האפליקציה רשאי בכל עת, לפי שיקול דעתו, לשנות את דרכי והיקף השימוש באפליקציה לרבות אפשרויות הגישה החינמיות ו/או בתשלום.`,
            `11.3 על המשתמש להזין פרטים מזהים עדכניים ומדויקים.`,
            `11.4 בעל האפליקציה רשאי לעדכן מעת לעת את תעריפי השימוש באפליקציה. בעל האפליקציה יודיע למשתמשים מראש על עדכון תעריפים, ועל האופן שבו עליהם לאשר את המשך השימוש באפליקציה לאור השינויים.`,
          ]}
        />

        <ParagraphSection
          title="12. ביטול ההרשמה לאפליקציה"
          paragraphs={[
            `התקנון יעמוד בתוקפו החל ממועד תחילת השימוש באפליקציה במכשיר של המשתמש, ועד מחיקתה של האפליקציה ממכשיר הקצה של המשתמש.`,
          ]}
        />

        <ParagraphSection
          title="13. סמכות שיפוט"
          paragraphs={[
            `הדין החל על כל סכסוך או מחלוקת בנוגע לתקנון זה יהיה הדין הישראלי וסמכות השיפוט הבלעדית והייחודית בכל עניין הנוגע לתקנון תנאי שימוש זה יהיה לבית משפט אשר לו הסמכות העניינית בירושלים.`,
          ]}
        />

        <ParagraphSection
          title="14. שירות לקוחות"
          paragraphs={[
            `בכל פניה, בירור תלונה או שאלה, לקוחות האפליקציה מוזמנים לפנות לבעל האפליקציה באמצעות כתובת הדואר האלקטרוני - Support@echadapp.com`,
          ]}
        />

        <Typography
          fontWeight={500}
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2 }}
        >
          תקנון זה מהווה יצירה מוגנת על ידי חוק זכויות יוצרים. אין להעתיק, לפרסם
          ו/או לעשות כל שימוש ללא אישור מבעל הזכויות.
        </Typography>
      </Stack>
    </MainContentWrapper>
  );
};

export default TermsPage;
